import { useState } from "react";
import { api, mutate, errorMessage } from "../lib/api";
import { formatCHF } from "../lib/format";
type Draft = { id: string; recipient_name: string; total_rappen: number };
export function DraftArchive({
  tenantId,
  onRestored,
}: {
  tenantId: string;
  onRestored: () => void;
}) {
  const [drafts, setDrafts] = useState<Draft[]>([]),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  async function load() {
    try {
      setDrafts((await api<{ drafts: Draft[] }>(`/tenants/${tenantId}/draft-archive`)).drafts);
    } catch (e) {
      setError(errorMessage(e));
    }
  }
  return (
    <details
      className="my-4 rounded-xl border p-4"
      onToggle={(e) => {
        if (e.currentTarget.open) void load();
      }}
    >
      <summary className="cursor-pointer text-sm">Gelöschte Entwürfe wiederherstellen</summary>
      <p className="my-3 text-sm text-slate-500">
        Die Wiederherstellung prüft, ob die Zeiträume inzwischen erneut verrechnet oder übersprungen
        wurden.
      </p>
      {drafts.map((d) => (
        <div key={d.id} className="flex items-center justify-between gap-3 border-t py-2 text-sm">
          <span>
            {d.recipient_name} · {formatCHF(d.total_rappen)}
          </span>
          <button
            className="btn-sm"
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try {
                await mutate(`/tenants/${tenantId}/draft-archive/${d.id}/restore`);
                await load();
                onRestored();
                setError("");
              } catch (e) {
                setError(errorMessage(e));
              } finally {
                setBusy(false);
              }
            }}
          >
            Wiederherstellen
          </button>
        </div>
      ))}
      {error && (
        <p className="text-red-700" role="alert">
          {error}
        </p>
      )}
    </details>
  );
}
